import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, Phone } from "lucide-react";
import { LOGO_URL, WHATSAPP_LINK, CONTACT_EMAIL, INSTAGRAM, NAV_LINKS } from "../lib/config";

export default function Footer() {
  return (
    <footer className="relative bg-owt-forest text-owt-surface pt-24 pb-10 overflow-hidden" data-testid="footer">
      {/* Map contour SVG */}
      <svg className="absolute inset-0 w-full h-full opacity-[0.06]" viewBox="0 0 1200 800" preserveAspectRatio="none">
        <path d="M0 400 Q 300 300 600 400 T 1200 380" stroke="currentColor" strokeWidth="1" fill="none" strokeDasharray="4 4"/>
        <path d="M0 500 Q 300 600 600 500 T 1200 480" stroke="currentColor" strokeWidth="1" fill="none" strokeDasharray="4 4"/>
        <circle cx="200" cy="400" r="4" fill="currentColor"/>
        <circle cx="800" cy="390" r="4" fill="currentColor"/>
      </svg>

      <div className="relative mx-auto max-w-[1600px] px-5 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 md:gap-6">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4 mb-6">
              <img src={LOGO_URL} alt="Once Way Travel" className="h-14 w-14 rounded-full bg-owt-surface p-1"/>
              <div>
                <div className="font-display text-2xl font-bold">Once Way Travel</div>
                <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-owt-sand opacity-70">Trips that only happen once</div>
              </div>
            </div>
            <p className="max-w-md text-owt-sand/80 leading-relaxed">
              A boutique travel studio by Tejas & Aishwarya, curating small-group journeys across seventeen countries — and counting.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-owt-sand/60 mb-4">Navigate</div>
            <ul className="space-y-2">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="hover:text-owt-terracotta transition-colors" data-testid={`footer-${l.label.toLowerCase()}`}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-owt-sand/60 mb-4">Get in touch</div>
            <ul className="space-y-3">
              <li className="flex items-center gap-3"><Mail className="w-4 h-4" /><a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-owt-terracotta">{CONTACT_EMAIL}</a></li>
              <li className="flex items-center gap-3"><Phone className="w-4 h-4" /><a href={WHATSAPP_LINK()} className="hover:text-owt-terracotta">+91 86603 38714</a></li>
              <li className="flex items-center gap-3"><Instagram className="w-4 h-4" /><a href={INSTAGRAM} target="_blank" rel="noreferrer" className="hover:text-owt-terracotta">@oncewaytravel</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-owt-surface/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-mono text-[10px] tracking-[0.2em] uppercase text-owt-sand/60">
          <div>© {new Date().getFullYear()} Once Way Travel · Bengaluru, India</div>
        </div>
      </div>
    </footer>
  );
}
